export enum QuestionMapping {
  FIRST_NAME = "first_name",
  LAST_NAME = "last_name",
  EMAIL = "email",
  PHONE_NUMBER = "phone_number",
  DATE_OF_BIRTH = "date_of_birth",
  GENDER = "gender",
  PRONOUNS = "pronouns",
  ADDRESS = "address",
  ADDRESS_LINE_TWO = "address_line_two",
  CITY = "city",
  STATE = "state",
  ZIP_CODE = "zip_code",
  COUNTRY = "country",
  LEAD_SOURCE = "lead_source",
  SIGNATURE = "signature",
  PREFERRED_PHARMACY = "preferred_pharmacy",

  WEIGHT = "weight",
  HEIGHT = "height",

  ALLERGIES = "allergies",
  MEDICATIONS = "medications",
  FAMILY_HISTORY = "family_history",
  MEDICAL_HISTORY = "medical_history",
  PRESCRIPTIONS = "prescriptions",
  SURGICAL_HISTORY = "surgical_history",
  SOCIAL_HISTORY = "social_history",
  PATIENT_REPORTED_SYMPTOMS = "patient_reported_symptoms",
  AUTOIMMUNE_DISORDERS = "autoimmune_disorders",
  SKIN_CONDITIONS = "skin_conditions",
  NEUROLOGICAL_CONDITIONS = "neurological_conditions",

  PAYMENT_METHOD = "payment_method",
  OPTED_IN_TO_SMS_MARKETING = "opted_in_to_sms_marketing",
  OPTED_IN_TO_EMAIL_MARKETING = "opted_in_to_email_marketing",
  OPTED_IN_TO_SOCIAL_MEDIA = "opted_in_to_social_media",
  AI_SCRIBE_CONSENT = "ai_scribe_consent",

  PRIMARY_INSURER_NAME = "primary_insurer_name",
  PRIMARY_PVERIFY_CODE = "primary_pverify_code",
  PRIMARY_MEMBER_ID = "primary_member_id",
  PRIMARY_GROUP_ID = "primary_group_id",
  PRIMARY_POLICY_HOLDER_NAME = "primary_policy_holder_name",
  PRIMARY_POLICY_HOLDER_DOB = "primary_policy_holder_dob",
  PRIMARY_PHONE_NUMBER = "primary_phone_number",

  SECONDARY_INSURER_NAME = "secondary_insurer_name",
  SECONDARY_PVERIFY_CODE = "secondary_pverify_code",
  SECONDARY_MEMBER_ID = "secondary_member_id",
  SECONDARY_GROUP_ID = "secondary_group_id",
  SECONDARY_POLICY_HOLDER_NAME = "secondary_policy_holder_name",
  SECONDARY_POLICY_HOLDER_DOB = "secondary_policy_holder_dob",
  SECONDARY_PHONE_NUMBER = "secondary_phone_number",
}
